import * as React from "react";
import { forwardRef } from "react";
const SvgInformation = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8 7.314c.379 0 .686.307.686.686v2.926a.686.686 0 0 1-1.372 0V8c0-.379.307-.686.686-.686M8.007 4.388a.686.686 0 0 1 0 1.372H8a.686.686 0 1 1 0-1.372z" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m0 1.371A6.629 6.629 0 1 0 8 14.63 6.629 6.629 0 0 0 8 1.37", clipRule: "evenodd" }));
const ForwardRef = forwardRef(SvgInformation);
export { ForwardRef as ReactComponent };
